module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1252.c6d7c113.png";